<div class="modal-body">
 <iframe [src]="sanitizer.bypassSecurityTrustResourceUrl(url)" width="100%" height="100%" frameborder="0"></iframe>
</div>
